import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconEmojiToReview: FC<ComponentProps<typeof IconWrapper>> = (props) => {
  const { size = 20, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5013 4.99996V9.99996L13.8346 11.6666M18.8346 9.99996C18.8346 14.6023 15.1037 18.3333 10.5013 18.3333C5.89893 18.3333 2.16797 14.6023 2.16797 9.99996C2.16797 5.39759 5.89893 1.66663 10.5013 1.66663C15.1037 1.66663 18.8346 5.39759 18.8346 9.99996Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </IconWrapper>
  )
}
